import { Flex } from "@chakra-ui/layout";

interface ContentItemProps {
  titulo: string;
  descricao?: string;
  mb?: string;
  descricaoFontSize?: string;
}

export default function ContentItem({
  titulo,
  descricao,
  mb = "3px",
  descricaoFontSize = "12px",
}: ContentItemProps) {
  return (
    <Flex direction="column" mb={mb}>
      <Flex color="#768398" fontSize="12px">
        {titulo}
      </Flex>
      <Flex fontSize={descricaoFontSize}>{descricao}</Flex>
    </Flex>
  );
}
